import * as React from "react";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {PlaylistItem, PlaylistItemProps} from "./PlaylistItem";
import styles from './PlaylistItem.module.scss';

interface SortablePlaylistItemProps extends PlaylistItemProps {
    id: string;
}

export const SortablePlaylistItem: React.FC<SortablePlaylistItemProps> = ({id, ...props}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({id});

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        position: 'relative',
        zIndex: isDragging ? 1 : 0,
    };

    return (
        <div ref={setNodeRef} style={style}>
            <PlaylistItem {...props}
                dragHandle={
                    <div className={styles.playlistItem__dragHandle} {...attributes} {...listeners}>
                        <DragIndicatorIcon fontSize="small"/>
                    </div>
                }
            />
        </div>
    );
};
